import { SyncOutlined } from '@ant-design/icons';
import React from 'react';

export const SpinLoadingIcon = ({ size }: { size?: string }) => {
  const sizes = {
    extraSmall: '5px',
    small: '10px',
    medium: '25px',
    large: '50px',
    extraLarge: '75px',
  };
  return (
    <div className="mt-3 flex justify-center rounded-[10px] align-middle">
      <SyncOutlined className="text-primary" style={{ fontSize: `${sizes[size ?? 'extraLarge']}` }} spin />
    </div>
  );
};
